import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import DefaultScenario from './ScenarioPicker/Default';
import ScenarioWithSelected from './ScenarioPicker/ScenarioWithSelected';

const ScenarioPicker = (props) => {
  const { scenarioResource } = props;
  const Component = pickWithPriority(scenarioResource, [
    [fr.relationships.select.name, ScenarioWithSelected],
  ],
  DefaultScenario);

  return <Component {...props} />;
};

export default ScenarioPicker;
